import { render } from "./PuxPopover.pug?vue&type=template&id=7c6107c5&lang=pug"
import script from "./PuxPopover.js?vue&type=script&lang=js"
export * from "./PuxPopover.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__